import { useEffect, useState } from "react";
import { getBranchName } from "../services/dashboard"; // adjust path as needed

export const useBranchNames = () => {
  const [branchOptions, setBranchOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchBranchNames = async () => {
    setLoading(true);
    try {
      const response = await getBranchName();
      const branchNames = response.data.map(
        (branch: { branch_name: string }) => branch.branch_name
      );
      setBranchOptions(branchNames);
    } catch (error) {
      console.error("Error fetching branch names", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Fetch only once on mount
    fetchBranchNames();
  }, []);

  return { branchOptions, loading, fetchBranchNames };
};
